'use strict'

;

var buyerHandler = function(){


	/*

	 * text:提示内容

	 * title:表示标题内容

	 */

	var success = function(text,title) {

		if(!title) {

			title = "Success!";//操作成功

		}

		alert("success", text,title);

	};

	

	// 消息提示

	var info = function(text) {

		alert("info", text,"Notice");//提示

	};


	// 危险

	var danger = function(text) {

		alert("error", text,"Unknown Error!");//未知错误

	};


	// 警告

	var warning = function(text) {

		alert("warning", text,"Fail to operate");//错误失败

	};


	var isInitAlert = false;

	var alert = function(type, text,title) {

		if(!isInitAlert) {

			toastr.options = {

					  "closeButton": true,

					  "debug": false,

					  "positionClass": "toast-top-right",

					  "onclick": null,

					  "showDuration": "1000",

					  "hideDuration": "1000",

					  "timeOut": "5000",

					  "extendedTimeOut": "1000",

					  "showEasing": "swing",

					  "hideEasing": "linear",

					  "showMethod": "fadeIn",

					  "hideMethod": "fadeOut"

				};

			isInitAlert = true;

		}

		toastr[type](text, title);

	};

	

	var closebtn = function(closebtn){

		if($(closebtn)[0].tagName=="A"){

			if($(closebtn).attr("onclick") && $(closebtn).attr("onclick") == "javascript:void(0);") {

				return;

			}

			$(closebtn).attr("clickData",$(closebtn).attr("onclick"));

			$(closebtn).attr("onclick","javascript:void(0);");

		}else{

			$(closebtn).attr("disabled","disabled");

		}

	};


	/**

	 * 提交错误,重新激活按钮

	 */

	var openbtn = function(openbtn){

		if($(openbtn)[0].tagName=="A"){

			if($(openbtn).attr("clickData")) {

				$(openbtn).attr("onclick",$(openbtn).attr("clickData"));

			}

		}else{

			$(openbtn).removeAttr('disabled');

		}

	};

	

	/***

	 * 初始化

	 */

	var init = function (mainId) {

		/**表单验证初始化**/

		formValidateInit(mainId);

		/**tab切换初始化**/

		bootstrapWizardInit(mainId);

		/****

		 * 暂时不知道干嘛用的

		 */

		$('.set-full-height').css('height', 'auto');

		/***

		 * 头部弹出框提示:

		 */

		$("[data-toggle='popover']").popover();

		/***

		 * 选择延保点击事件

		 */

		let $form = $('form.initCustomForm' + mainId);

		let $wizardCard = $('div#custom_wizardProfile' + mainId);

		/***

		 * 不选择礼品点击事件

		 */

		$form.find('input[name="reviewGift.hasNotGifts"]').change(function(){

			if ($(this).is(':checked')) {

				$form.find('div.giftCheckDiv' + mainId).hide();

//				$form.find('div[data-filed="giftSellergiftsaleDiv"]').hide();

				$wizardCard.bootstrapWizard('hide', 4);

				$wizardCard.find('.btn-next').hide();

				$wizardCard.find('.btn-finish').show();

				

				/**风格三，空白页展示文本信息**/

				if ($form.hasClass('custom_form_concise')) {

					$form.find('div[data-filed="custom_gift_not_check_div"]').show();

				}


				$(".finish-input").removeAttr("data-toggle data-target").attr("onclick","$(this).closest('form').submit();");


			} else {

				$form.find('div.giftCheckDiv' + mainId).show();

				$wizardCard.bootstrapWizard('display', 4);

				$wizardCard.find('.btn-next').show();

				$wizardCard.find('.btn-finish').hide();

				/**风格三，空白页展示文本信息**/

				if ($form.hasClass('custom_form_concise')) {

					$form.find('div[data-filed="custom_gift_not_check_div"]').hide();

				}

				let type = $form.find('select[name="reviewGift.sellerGiftId"]').find('option:checked').data('gift-type');

				showGiftType(type, $form);


			}

		});

		

		/***

		 * 星级点击事件

		 */

		$form.find('span.custom_star_score i').click(function(){

			let $obj = $(this),

				index = $obj.data('index')

			;

			if ($obj.hasClass('fa-star-o')) {

				//选中

				$obj.removeClass('fa-star-o');

				if (index > 1) {

					$form.find('span.custom_star_score i').each(function(i, element){

						if (parseInt($(element).data('index')) < index && $(element).hasClass('fa-star-o')) {

							$(element).removeClass('fa-star-o');

						}

					});

				}

			} else {

				//去除选中

				$obj.addClass('fa-star-o');

				if (index < $form.find('span.custom_star_score i').length) {

					$form.find('span.custom_star_score i').each(function(i, element){

						if ($(element).data('index') > index && !$(element).hasClass('fa-star-o')) {

							$(element).addClass('fa-star-o');

						}

					});

				}

				/***

				 * 只有一星时不允许取消

				 */

				if (index == 1) {

					$obj.removeClass('fa-star-o');

				}

			}

			let reviewGrade = 0;

			$form.find('span.custom_star_score i').each(function(i, element){

				if (!$(element).hasClass('fa-star-o')) {

					reviewGrade++;

				}

			});

			$form.find('input[name="reviewGift.reviewGrade"]').val(reviewGrade);

			

			if (reviewGrade >= 4) {

				/***

				 * 复制评价内容到剪切板

				 */

				clipboardInit(mainId);

			}

		});

		

		/***

		 * 平台改变事件

		 */

		$('form.initCustomForm' + mainId).find('select[name="platform"]').change(function(){

			/**订单下商品选择框初始化**/

			//sellerSkuIdOnChangeInit(mainId);

			tradeOrderDetailOnChangeInit(mainId);

		});

		/***

		 * 商品改变事件

		 */

		$('form.initCustomForm' + mainId).find('select[name="sellerSkuId"]').change(function(){

			/**选择商品事件**/

			//sellerSkuIdOnChange(mainId);

			tradeOrderDetailSkuOnChange(mainId);

		});


		/***

		 * 礼品选择改变事件

		 */

		$('form.initCustomForm' + mainId).find('select[name="reviewGift.sellerGiftId"]').change(function(){

			/**选择礼品事件**/

			sellerGiftIdOnChange(mainId);

		});

	};

	var firstNameMsg = 'Please enter the First Name';

	/**表单验证初始化**/

	var formValidateInit = function (mainId) {

		$('form.initCustomForm' + mainId).validate({

//			onfocusout: false,//默认值是true，表示当焦点离开当前表单元素就会对其进行验证。

//			onkeyup: false,//默认值是true，表示当按键弹起时，就会对当前表单元素进行验证。

//			focusInvalid: false ,//默认值是true，当验证无效时，焦点跳到第一个无效的表单元素。

//			focusCleanup: true,//默认值是false。如果为true，当表单得到焦点时，移除在该表单上的errorClass并隐藏所有错误消息。避免与focusInvalid一起使用。

			onfocusout: function(element) {

				if ($(element).attr('name') != 'tradeCode') {

					$(element).valid();

				}

			},

			onkeyup: function(element) {

				if ($(element).attr('name') != 'tradeCode') {

					$(element).valid();

				}

			},

			focusInvalid: function(element) {

				if ($(element).attr('name') != 'tradeCode') {

					$(element).valid();

				}

			},

//			focusCleanup: function(element) {

//				if ($(element).attr('name') == 'tradeCode') {

//					return true;

//					$(element).valid();

//				}

//				return false;

//			},

			rules: {

            	tradeCode: {

                	required: true,

        			maxlength: 100,

        			tradeCodeCheck : true,

                },

                contactFirst : {

                	required: true,

        			maxlength: 100

                },

                contactLast : {

                	required: true,

        			maxlength: 100

                },

                buyerEmail : {

                	required: true,

                	email : true,

                	maxlength : 100

                },

                'reviewGift.buyerAddress' : {

                	required: true,

                	maxlength : 500

                },

                'reviewGift.buyerAddress2' : {

                	maxlength : 500

                },

               'reviewGift.buyerAddress3' : {

                	maxlength : 500

                },

                'reviewGift.buyerPostCode' : {

                	required: true,

                	maxlength : 100,

//                	digits : true

                },

               'reviewGift.buyerCity' : {

                	maxlength : 100

                },

               'reviewGift.buyerCountry' : {

                	maxlength : 100

                },

               'reviewGift.buyerMobile' : {

                	maxlength : 20,

//                	digits : true

                },

                hasExtensionWarrantyCheck : {

                	required: true,

                },

                sellerSkuId : {

                	required: true,

                },

                paidTimeStr : {

                	required: true,

                },

                platform : {

                	required: true,

                },

                countryCode : {

                	required: true,

                },

                'reviewGift.reviewContent' : {

                	maxlength : 5000,

                },

                'reviewGift.sellerGiftId' : {

                	required: true,

                },

                'reviewGift.confirmEmail' : {

                	required : true,

                	email : true,

                	maxlength : 100

                },

                'reviewGift.paypal' : {

                	required: true,

                }

            },

            messages: {

            	tradeCode: {

                	required: 'Please enter the Order ID',//请输入订单号

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                contactFirst : {

                	required: function (){

                		return firstNameMsg;

                	},//请输入First Name

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                contactLast : {

                	required: 'Please enter the Last Name',//请输入Last Name

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                buyerEmail : {

                	required: 'Please enter the Email',//请输入邮箱

                	email : 'Please enter a correct Email',//请输入正确的邮箱格式

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerAddress' : {

                	required : 'Please enter the Address',//请输入地址

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerAddress2' : {

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerAddress3' : {

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerPostCode': {

                	required: 'Please enter the PostCode',//请输入邮编

//                	digits : '只能输入数字',

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerCity' : {

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerCountry' : {

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.buyerMobile' : {

                	maxlength: $.validator.format("You can enter up to {0} characters"),//最多可以输入{0}个字符

//                	digits : '只能输入数字'

                },

                hasExtensionWarrantyCheck : {

                	required: 'Please agree to the protocol',//请同意协议

                },

                sellerSkuId : {

                	required: 'Please select a product',//请选择商品

                },

                paidTimeStr : {

                	required: 'Please select paidTime',//请选择付款时间

                },

                platform : {

                	required: 'Please select the platform',//请选择平台

                },

                countryCode : {

                	required: 'Please select the country',//请选择国家

                },

                'reviewGift.reviewContent' : {

                	maxlength: $.validator.format("You can enter up to {0} characters"),//最多可以输入{0}个字符

                },

                'reviewGift.sellerGiftId' : {

                	required: 'Please select a gift',//请选择礼品

                },

                'reviewGift.confirmEmail' : {

                	required : 'Please enter the Confirm email',//请填写确认邮箱

                	email : 'Please enter a correct Email',//请输入正确的邮箱格式

                	maxlength: $.validator.format("You can enter up to {0} characters")//最多可以输入{0}个字符

                },

                'reviewGift.paypal' : {

                	required: 'Please enter the PayPal',//请填写PayPal账号

                }

            },

            errorPlacement: function(error, element) {

            	if ($(element).closest('form').hasClass('custom_form_concise') && element.parent().hasClass('input-group')) {

            		/***只有风格三才这样处理***/

            		element.parent().after(error);

            	} else {

            		error.appendTo(element.parent());

            	}

            },

            submitHandler: function(form) {

            	let $finishBtn = $(form).find('[name="finish"]');

            	closebtn($finishBtn);

            	let type = $(form).find('select[name="reviewGift.sellerGiftId"]').find('option:checked').data('gift-type');

            	switch (type) {

	    			case "COUPON":

	    			case "GIFTCARD":

	    				$(form).find('input[name="reviewGift.paypal"]').val("");

	    				$(form).find('input[name="reviewGift.buyerAddress"]').val("");

	    				$(form).find('input[name="reviewGift.buyerAddress2"]').val("");

	    				$(form).find('input[name="reviewGift.buyerAddress3"]').val("");

	    				$(form).find('input[name="reviewGift.buyerCity"]').val("");

	    				$(form).find('input[name="reviewGift.buyerPostCode"]').val("");

	    				$(form).find('input[name="reviewGift.buyerCountry"]').val("");

	    				$(form).find('input[name="reviewGift.buyerMobile"]').val("");

	    				break;

	    			case "CASH":

	    				$(form).find('input[name="reviewGift.confirmEmail"]').val("");

	    				$(form).find('input[name="reviewGift.buyerAddress"]').val("");

	    				$(form).find('input[name="reviewGift.buyerAddress2"]').val("");

	    				$(form).find('input[name="reviewGift.buyerAddress3"]').val("");

	    				$(form).find('input[name="reviewGift.buyerCity"]').val("");

	    				$(form).find('input[name="reviewGift.buyerPostCode"]').val("");

	    				$(form).find('input[name="reviewGift.buyerCountry"]').val("");

	    				$(form).find('input[name="reviewGift.buyerMobile"]').val("");

	    				break;

	    			case "ENTITY":

	    				$(form).find('input[name="reviewGift.confirmEmail"]').val("");

	    				$(form).find('input[name="reviewGift.paypal"]').val("");

	    				break;

	    			default:

	    				break;

	    		}

            	

            	 $.ajax({

         			type : "post",

         			url : 'buyer/buyerRegister',

         			data : $(form).serializeArray(),

         			dataType : "json",

         			success : function(data) {

         				if (data.status == "success") {

         					success('Product register successfully');//注册成功

         					let url = '/success/' + data.responseData.registerProductId;

         					let timeOut = 600;

         					// if ($(form).find('input[name="marketingType"]').val() == 'WARRANTY_AND_REVIEW_GIFT'

         					// 	&& !$(form).find('input[name="reviewGift.hasNotGifts"]').is(':checked')

         					// 	/*&& $(form).find('input[name="reviewGift.hasNotGifts"]').attr('checked') != 'checked'*/) {

         					// 	if ($(form).find('input[name="reviewGift.reviewGrade"]').val() >= 4) {

         					// 		// info('We will record your review and copy your review to Clipboard, you can paste it to next window to help other buyers to learn more of the product you purchased.');//We will record your review and copy your review to Clipboard, you can paste it to next window to help other buyers to learn more of the product you purchased.

         					// 		if ($(form).find('input[name="sellerSkuReview"]').val().length > 0) {

         					// 			let urlTo = $(form).find('input[name="sellerSkuReview"]').val();

								// 		// var tempwindow = window.open();

								// 		// tempwindow.location = urlTo;

								// 		// window.open(urlTo,"_blank")

							 //

								// 		$("#alink").attr("href", urlTo);

								// 		$("#spanlink").click();

         					// 		}

							 //

         					// 	} else {

         					// 		// info('We will record your review and improve our product. Thanks for your help.');//We will record your review and improve our product. Thanks for your help.

         					// 	}

         					// 	timeOut = 1500;

         					// }

         					setTimeout(function() {

    							window.location.href = url;

    							openbtn($finishBtn);

    						}, timeOut);

         				} else {

         					let msg = data.errorMessage;

         					if (msg != null && msg.length > 0) {

         						warning(msg);

         					} else {

         						warning('Register failed, please retry');//注册失败，请重试.

         					}

            				openbtn($finishBtn);

         				}

         			},

         			error : function(XMLHttpRequest, textStatus, errorThrown) {

        				danger('Something went wrong, please contact support');//操作异常，请联系管理员

        				openbtn($finishBtn);

         			}

         		});

            	return false;

            }

        });


		$('#wellReceivedPrompt').on('show.bs.modal', function () {

			// 执行一些动作...

			var reviewGrade = $("#customBuyerForm").find('input[name="reviewGift.reviewGrade"]').val();

			if(reviewGrade>=4){

				$("#wellReceivedPrompt .modal-body").text("We will record your review and copy your review to Clipboard, you can paste it to next window to help other buyers to learn more of the product you purchased.");

			}else{

				$("#wellReceivedPrompt .modal-body").text("We will record your review and improve our product. Thanks for your help.");

			}

		})


		/***

		 * 交易单号验证

		 */

		$.validator.addMethod("tradeCodeCheck", function(value, element) { 

			if(value == null || value == undefined || value.length <= 0){

				return false;

			}

			let $obj = $(element), 

				$form = $obj.closest('form'),

				sessionKey = $form.find('input[name="sessionKey"]').val(),

				contactFirst = $form.find('input[name="contactFirst"]').val(), 

				contactLast = $form.find('input[name="contactLast"]').val(), 

				buyerEmail = $form.find('input[name="buyerEmail"]').val(), 

				visitTimeStamp = $form.find('input[name="visitTimeStamp"]').val(), 

				brandName = $form.find('input[name="brandName"]').val(),

				tradeCode = $obj.val();

			;

			let result = false;

			$.ajax({

				type : "post",

				url : 'buyer/tradeCodeCheck',

				async: false,

//				data : {"sessionKey" : sessionKey, 'tradeCode' : value},

				data : {"sessionKey" : sessionKey, 'tradeCode' : tradeCode, 'contactFirst': contactFirst, 'contactLast' : contactLast, 'buyerEmail':buyerEmail, 'visitTimeStamp':visitTimeStamp, 'sellerBrandName':brandName},

				dataType : "json",

				success : function(data) {

					if (data.status == "success") {

						let valid1 = validWarrantyLink($form);

						if (valid1 == true){

							result = true;

						}else {

							return false;

						}

					} else {

						let msg = data.errorMessage;

						if (msg != null && msg.length > 0) {

							$(element).data('error-msg', msg);

						}

					}

				},

				error : function(XMLHttpRequest, textStatus, errorThrown) {

    				danger('Something went wrong, please contact support');//操作异常，请联系管理员

				}

			});

			return result;

		}, function(params, element) {

			return $(element).data('error-msg');

		});

	};


	/**原始风格*/

	var validWarrantyLink = function(form) {

		let valid0 = false;

		$.ajax({

			type : "post",

			url : '/buyer/validWarrantyLink',

			async: false,

			data : $(form).serializeArray(),

			dataType : "json",

			success : function(data) {

				if(data.status=='success'){

					valid0 = true;

				}else{

					warning("The order does not exist, please contact customer service!");

				}

			}

		});

		return valid0

	};


	/**自定义风格*/

	var validWarrantyLinkByCustom = function(form) {

		let valid0 = false;

		$.ajax({

			type : "post",

			url : '/buyer/validWarrantyLink',

			async: false,

			data : $(form).serializeArray(),

			dataType : "json",

			success : function(data) {

				if(data.status=='success'){

					/**

					 * 验证订单是否已锁定

					 * 单个商品: 1. 已锁定>>>弹框提示

					 *          2. 未锁定>>>继续走流程

					 * 多个商品: 1. 全部锁定>>>弹框提示

					 *          2. 全部未锁定>>>继续走流程

					 *          3. 部分锁定>>>走第二步选择商品{

					 *              <1> 选择的商品已锁定>>>弹框提示

					 *              <2> 选择的商品未锁定>>>继续走流程

					 *          }

					 */


					form.submit();

					valid0 = true;

				}else{

					warning("The order does not exist, please contact customer service!");

				}

			}

		});

		return valid0

	};


	var validWarrantyLinkByItemNo = function(form) {

		$.ajax({

			type : "post",

			url : '/buyer/validWarrantyLinkByItemNo',

			data : $(form).serializeArray(),

			dataType : "json",

			success : function(data) {

				if(data.status=='success'){

					form.submit();

				}else{

					warning("The product you selected does not exist, please contact customer service!");

				}

			}

		});

	};


	var validWarrantyLinkBySellerSkuId = function(form) {

		let bool = true;

		$.ajax({

			type : "post",

			url : '/buyer/validWarrantyLinkBySellerSkuId',

			data : form,

			async: false,

			dataType : "json",

			success : function(data) {

				if(data.status=='success'){


				}else{

					bool = false;

				}

			}

		});

		return bool;

	};


	/**判断订单是否已锁定*/

	var validWarrantyLinkBySellerSkuId = function(form) {

		let bool = true;

		$.ajax({

			type : "post",

			url : '/buyer/validWarrantyLinkBySellerSkuId',

			data : form,

			async: false,

			dataType : "json",

			success : function(data) {

				if(data.status=='success'){


				}else{

					bool = false;

				}

			}

		});

		return bool;

	};


	function querySkuStatusBySkuId($form){

		var result = true;

		$.ajax({

			type : "post",

			url : 'buyer/querySkuStatusBySkuId',

			async: false,

			data : $form.serializeArray(),

			dataType : "json",

			success : function(data) {

				if (data.status == "success" && data.responseData!=null) {

					result = data.responseData.status;

				}else{

					result = false;

				}

			}

		});

		return result;

	};

	

	

	/***

	 * tab切换初始化

	 */

	var bootstrapWizardInit = function (mainId) {

		let $wizardCard = $('div#custom_wizardProfile' + mainId)

		;

		$wizardCard.bootstrapWizard({

			'tabClass': 'nav nav-pills',

			'nextSelector': '.btn-next',

			'firstSelector' : '.custom-btn-regitsterSearch',

//			'previousSelector': '.btn-previous',

			onNext: function(tab, navigation, index) {

				let $valid = $wizardCard.find('form').valid();

				if(!$valid) {

					return false;

				}

				if ($(tab).find('a').data('custom-type') == 'description'){

					return initDescriptionNextTabl($(tab).closest('form'), mainId);

				} else if ($(tab).find('a').data('custom-type') == 'chooseOrderDetail') {

					//延保界面访问时间

					$(tab).closest('form').find('input[name="warrantyStepTimeStamp"]').val(new Date().getTime());

					let skuId = $(tab).closest('form').find('select[name="sellerSkuId"]').data("sku-id");

					console.log(skuId);

					if (skuId == null || skuId == "" || skuId==undefined) {//没有找到的本地商品提示当前商品不支持延保

						warning("This product does not support extended warranty for the time being.");

						return false;

					}else{

						let valid = validWarrantyLinkBySellerSkuId($(tab).closest('form').serializeArray());

						if (valid == true){

							let status = querySkuStatusBySkuId($(tab).closest('form'));

							if(!status){

								warning("This product does not support extended warranty for the time being.");

								return false;

							}

						}else {

							warning("The product you selected does not exist, please contact customer service!");

							return false;

						}

					}

					 let marketingtype = $(tab).closest('form').find('input[name="marketingType"]').val();

					 console.log(marketingtype);

//					let marketingtype = $(tab).closest('form').find('select[name="sellerSkuId"]').find('option:checked').data('sku-marketingtype');

//					$(tab).closest('form').find('input[name="marketingType"]').val(marketingtype);

					if (marketingtype != 'WARRANTY_AND_REVIEW_GIFT') {

						/***

						 * 不属于索评送礼模式，则去除索评送礼tab[注意，此处优先去除下标比较高的位置，删除一个下标会更新下标位置]

						 */

						let chooseGiftIndex = $(tab).closest('form').find('a[data-custom-type="chooseGift"]').data('custom-index');

						let reviewIndex = $(tab).closest('form').find('a[data-custom-type="review"]').data('custom-index');

						$('div#custom_wizardProfile' + mainId).bootstrapWizard('remove', reviewIndex, true);

						$('div#custom_wizardProfile' + mainId).bootstrapWizard('remove', chooseGiftIndex, true);


						$(".finish-input").removeAttr("data-toggle data-target").attr("onclick","$(this).closest('form').submit();");

					}

				} else if ($(tab).find('a').data('custom-type') == 'hasExtensionWarranty') {

					//礼品界面访问时间

					$(tab).closest('form').find('input[name="reviewGift.giftStepTimeStamp"]').val(new Date().getTime());

					giftInitTable($(tab).closest('form'), mainId);

					//initChooseGiftTabl($(tab).closest('form'), mainId);

				} else if ($(tab).find('a').data('custom-type') == 'chooseGift') {

					//索评界面访问时间

					$(tab).closest('form').find('input[name="reviewGift.reviewStepTimeStamp"]').val(new Date().getTime());

					//默认选中五星

					$(tab).closest('form').find('span.custom_star_score').find('i[data-index="5"]').click();

				}

			},

			onPrevious : function(tab, navigation, index) {//单击上一个按钮时触发（返回false以禁用移动到上一步）

				return false;//禁用上一步

			},

			onInit : function(tab, navigation, index){

				let $total = navigation.find('li').length, $width = 100 / $total;

				let $display_width = $(document).width();

				if($display_width < 600 && $total > 3){

					$width = 50;

				}

				navigation.find('li').css('width', $width + '%');

				let $first_li = navigation.find('li:first-child a').html();

				let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');

				$wizardCard.find('div.wizard-navigation').append($moving_div);

				refreshAnimation($wizardCard, index);

				$wizardCard.find('.moving-tab').css('transition','transform 0s');

			},

			onTabClick : function(tab, navigation, index){

				return false;//不允许点击头部的菜单

//				return true;

			},

			onTabShow: function(tab, navigation, index) {

				let $total = navigation.find('li').length;

				let $current = index+1;

//				let $wizard = navigation.closest('.wizard-card');

				// If it's the last tab then hide the last button and show the finish instead

				if($current >= $total) {

					$wizardCard.find('.btn-next').hide();

					$wizardCard.find('.btn-finish').show();

				} else {

					$wizardCard.find('.btn-next').show();

					$wizardCard.find('.btn-finish').hide();

				}

				

				if ($current > 1) {

					$wizardCard.find('div.custom-btn-regitsterSearch').hide();

					$("html, body").animate({

						scrollTop: 0

					}, 600);

				}

				

//				/****

//				 * 选择订单下的商品之后，不允许点击上一步

//				 */

//				if ($(tab).find('a').data('custom-type') == 'hasExtensionWarranty') {

//					$wizardCard.find('input[name=previous]').hide();

//				}

//				else {

//					$wizardCard.find('input[name=previous]').show();

//				}

//				$wizardCard.find('a.custom-btn-regitsterSearch').hide();

				

				/***只有风格三才动态处理下一步、完成按钮***/

				if ($(tab).closest('form').hasClass('custom_form_concise')) {

					if ($(tab).find('a').data('custom-type') == 'hasExtensionWarranty'

						|| $(tab).find('a').data('custom-type') == 'review') {

						$(tab).closest('form').find('div.custom-agile_info_footer').addClass('custom-w3l_form_half');

					} else {

						if ($(tab).closest('form').find('div.custom-agile_info_footer').hasClass('custom-w3l_form_half')) {

							$(tab).closest('form').find('div.custom-agile_info_footer').removeClass('custom-w3l_form_half');

						}

					}

				}

				

				let button_text = navigation.find('li:nth-child(' + $current + ') a').html();

				setTimeout(function(){

					$wizardCard.find('.moving-tab').text(button_text);

				}, 150);

				let checkbox = $('.footer-checkbox');

				if(!index == 0){

					$(checkbox).css({

						'opacity':'0',

						'visibility':'hidden',

						'position':'absolute'

					});

				} else {

					$(checkbox).css({

						'opacity':'1',

						'visibility':'visible'

					});

				}

				refreshAnimation($wizardCard, index);

			}

		});

	};

	

	var refreshAnimation = function($wizard, index){

	    let total_steps = $wizard.find('li').length,

	    	move_distance = $wizard.width() / total_steps,

	    	step_width = move_distance;

	    move_distance *= index;

	    $wizard.find('.moving-tab').css('width', step_width);

	    $('.moving-tab').css({

	        'transform':'translate3d(' + move_distance + 'px, 0, 0)',

	        'transition': 'all 0.3s ease-out'

	    });

	};

	

	/***

	 * 点击下一步，初始化相关数据

	 */

	var initDescriptionNextTabl = function ($form, mainId) {

		let sessionKey = $form.find('input[name="sessionKey"]').val(),

			tradeCode = $form.find('input[name="tradeCode"]').val(),

			contactFirst = $form.find('input[name="contactFirst"]').val(), 

			contactLast = $form.find('input[name="contactLast"]').val(), 

			buyerEmail = $form.find('input[name="buyerEmail"]').val(), 

			visitTimeStamp = $form.find('input[name="visitTimeStamp"]').val(), 

			brandName = $form.find('input[name="brandName"]').val()

		;

		if (!$form.valid()) {

			return false;

		}

		let hasNext = true;

		$form.find('input[data-field="orderId"]').val(tradeCode);

		$.ajax({

			type : "post",

			url : 'buyer/getOrderDetailInfo',

			async: false,

			data : {"sessionKey" : sessionKey, 'tradeCode' : tradeCode, 'contactFirst': contactFirst, 'contactLast' : contactLast, 'buyerEmail':buyerEmail, 'visitTimeStamp':visitTimeStamp, 'sellerBrandName':brandName},

			dataType : "json",

			success : function(data) {

				if (data.status == "success") {

					/**初始化页面订单详情数据**/

//					initOrderDetailInfo(data.responseData.sellerSkuList, $form, mainId);

					console.log(data.responseData.tradeOrderDetailList);

					initTradeOrderDetailInfo(data.responseData.tradeOrderDetailList, $form, mainId);

					/**返回已经开始存储的买手注册id**/

					$form.find('input[name="id"]').val(data.responseData.registerProductRecordId);

					

					let countryConfigList = data.responseData.countryConfigList;

					if (countryConfigList && countryConfigList.length > 0) {

						let $countryCode = $form.find('[name="countryCode"]')

						$countryCode.find('option').remove();

						$countryCode.append('<option value="">' + 'Please Choose' + '</option>');

						for (let i = 0; i < countryConfigList.length; i++) {

							let countryConfig = countryConfigList[i];

							

							$countryCode.append('<option value=""></option>');

							let $lastOption = $countryCode.find('option:last');

							$lastOption.val(countryConfig.code);

							$lastOption.html(countryConfig.nameMsg);

						}

						if (countryConfigList.length == 1) {

							$countryCode.find('option[value="'+ countryConfigList[0].code +'"]').attr('selected', 'selected');

						}

					}

					

					let platformSet = data.responseData.platformSet;

					if (platformSet && platformSet.length > 0) {

						let $platform = $form.find('[name="platform"]')

						$platform.find('option').remove();

						$platform.append('<option value="">' + 'Please Choose' + '</option>');

						for (let i = 0; i < platformSet.length; i++) {

							let platform_ = platformSet[i];

							$platform.append('<option value=""></option>');

							let $lastOption = $platform.find('option:last');

							$lastOption.val(platform_);

							$lastOption.html(platform_);

						}

						if (platformSet.length == 1) {

							$platform.find('option[value="'+ platformSet[0] +'"]').attr('selected', 'selected');

						}

					}

				} else {

					let msg = data.errorMessgae;

					if (msg != null && msg.length > 0) {

						//提示信息

						warning(msg);

					} else {

						warning('Error getting order information, please retry');//获取订单信息失败，请重试。

					}

					hasNext = false;

				}

			},

			error : function(XMLHttpRequest, textStatus, errorThrown) {

				console.log(XMLHttpRequest);

				console.log(textStatus);

				console.log(errorThrown);

				hasNext = false;

				danger('Something went wrong, please contact support');//操作异常，请联系管理员

			}

		});

		

		/**选择商品事件**/

//		sellerSkuIdOnChange(mainId);

		return hasNext;

	};

	

	/***

	 * 初始化页面订单详情数据

	 */

	var initTradeOrderDetailInfo = function(tradeOrderDetailList, $form, mainId){

		let countryArray = new Array(), platformArray = new Array(), paidTimeArray = new Array(),orderDetailArray = new Array();

		$form.find('select[name="sellerSkuId"]').data('tradeOrderDetailList', tradeOrderDetailList);

		let tradeOrder = $form.find('input[data-field="orderId"]').val();

		console.log(tradeOrder);

		for (let i = 0; i < tradeOrderDetailList.length; i++) {

			let orderDetail = tradeOrderDetailList[i];

			/***

			 * 统计国家

			 */

			let countryCode = orderDetail.countryCode, isExistCountryCode = false;

			if (countryArray.length > 0) {

				for (let j = 0; j < countryArray.length; j++) {

					if (countryCode == countryArray[j]) {

						isExistCountryCode = true;

						break;

					}

				}

			}

			if (!isExistCountryCode) {

				countryArray.push(countryCode);

			}

			/***

			 * 统计平台

			 */

			let platform = orderDetail.platform, isExistPlatform = false;

			if (platformArray.length > 0) {

				for (let j = 0; j < platformArray.length; j++) {

					if (platform == platformArray[j]) {

						isExistPlatform = true;

						break;

					}

				}

			}

			if (!isExistPlatform) {

				platformArray.push(platform);

			}

			/***

			 * 统计付款时间

			 */

			let paidTimeStr = orderDetail.paidTimeStr, isExistPaidTimeStr = false;

			if (paidTimeArray.length > 0) {

				for (let j = 0; j < paidTimeArray.length; j++) {

					if (paidTimeStr == paidTimeArray[j]) {

						isExistPaidTimeStr = true;

						break;

					}

				}

			}

			if (!isExistPaidTimeStr) {

				paidTimeArray.push(paidTimeStr);

			}

			/***

			 * 统计asin

			 */

			let asin = orderDetail.itemNo, isItemNo = false;

			if (orderDetailArray.length > 0) {

				for (let j = 0; j < orderDetailArray.length; j++) {

					if (asin == orderDetailArray[j]) {

						isItemNo = true;

						break;

					}

				}

			}

			if (!isItemNo) {

				orderDetailArray.push(asin);

			}

		}

		//选择国家

		if (countryArray.length == 1) {

			$form.find('select[name="countryCode"]').find('option[value="'+ countryArray[0] +'"]').attr('selected', 'selected');

		}

		//选择平台

		if (platformArray.length == 1) {

			$form.find('select[name="platform"]').find('option[value="'+ platformArray[0] +'"]').attr('selected', 'selected');

		}

		//选择付款时间

		if (paidTimeArray.length == 1) {

			$form.find('input[name="paidTimeStr"]').val(paidTimeArray[0]);

		}

		/**初始化日期选择器**/

		datetimepicker(mainId);

		/**订单下商品选择框初始化方法**/

		tradeOrderDetailOnChangeInit(mainId);

		//选择商品

		if (orderDetailArray.length == 1) {

			let $option = $form.find('select[name="sellerSkuId"]').find('option[value="'+ orderDetailArray[0] +'"]');

			$option.attr('selected', 'selected');

			/**选择商品事件**/

			tradeOrderDetailSkuOnChange(mainId);

		}

	};

	

	/**订单下商品选择框初始化方法**/

	var tradeOrderDetailOnChangeInit = function(mainId){

		let $form = $('form.initCustomForm' + mainId), $obj = $form.find('select[name="sellerSkuId"]');

		let _platform = $form.find('select[name="platform"]').val();

		

		let tradeOrderDetailList = $obj.data('tradeOrderDetailList');

		console.log(tradeOrderDetailList);

		$obj.html('');

		$obj.html('<option value="">' + 'Please Choose' + '</option>');//请选择

		let asinArray = new Array();

		for (let i = 0; i < tradeOrderDetailList.length; i++) {

			let tradeOrder = tradeOrderDetailList[i];

			if (_platform != null && _platform != undefined && _platform.length > 0 && _platform != tradeOrder.platform) {

				continue;

			}

			let isExist = false;

			if (asinArray.length > 0) {

				for (let j = 0; j < asinArray.length; j++) {

					if (tradeOrder.itemNo == asinArray[j]) {

						isExist = true;

						break;

					}

				}

			}

			if (!isExist) {

				$obj.append('<option value=""></option>');

				let $lastOption = $obj.find('option:last');

				$lastOption.val(tradeOrder.itemNo);

				let saleSkuName = tradeOrder.saleSkuName;

				if (saleSkuName != null && saleSkuName != "" && saleSkuName.length > 50) {

					let nameStr = saleSkuName.substring(0, 50);

					$lastOption.html(nameStr + "......");

				}else{

					$lastOption.html(saleSkuName);

				}

				

				$lastOption.data('sku-name', tradeOrder.saleSkuName);

				$lastOption.data('sku-picurl', tradeOrder.saleSkuPic);

				$lastOption.data('order-detail-id', tradeOrder.orderDetailId);

				$lastOption.attr("title",tradeOrder.saleSkuName)

				asinArray.push(tradeOrder.itemNo);

			}

		}

		/**只有一个时默认选中**/

//		console.log(asinArray.length);

//		if (asinArray != null && asinArray.length == 1) {

//			$obj.find('option:last').attr('selected', 'selected');

//		}

		$obj.valid();

		/**选择商品事件**/

		tradeOrderDetailSkuOnChange(mainId);

	};

	

	/**选择商品事件**/

	var tradeOrderDetailSkuOnChange = function(mainId){

		let $form = $('form.initCustomForm' + mainId), $obj = $form.find('select[name="sellerSkuId"]');

		let name = $obj.find('option:checked').data('sku-name');

		if (name == null || name == undefined) {

			name = '';

		}

		let picurl = $obj.find('option:checked').data('sku-picurl');

		console.log(picurl);

		if (picurl == null || picurl == undefined || picurl == "") {

			picurl = '/assets/img/default-avatar.png';

		}

		$form.find('p[data-field="sellerSkuName"]').html(name);

		$form.find('img[data-field="sellerSkuPicurl"]').attr('src', picurl);

		let itemNo = $obj.val();

		console.log(itemNo);

		if (itemNo != null && itemNo != "") {

			let sessionKey = $form.find('input[name="sessionKey"]').val();

			console.log(sessionKey);

			let orderDetialId = $obj.find('option:checked').data('order-detail-id');

			$form.find('input[name="orderDetailId"]').val(orderDetialId);

			//根据选择的订单商品查询本地商品

			$.ajax({

				type : "post",

				url : 'buyer/getSellerSkuInfo',

				async: false,

				data : {"sessionKey" : sessionKey, 'itemNo' : itemNo},

				dataType : "json",

				success : function(data) {

					if (data.status == "success") {

						let itemNoMap = data.responseData.itemNoMap;

						if (itemNoMap != null) {

							$obj.data("sku-id",itemNoMap.seller_sku_id);

							//初始化数据时select[name="sellerSkuId"]存的是asin

							$obj.find('option:checked').val(itemNoMap.seller_sku_id);

						}else {

							$obj.data("sku-id","");

						}

						let skuMap = data.responseData.skuMap;

						if (skuMap != null) {

							let marketingType = skuMap.marketing_type;

							$form.find('input[name="marketingType"]').val(marketingType);

							let warrantyperiodextend = skuMap.warranty_period_extend;

							let is_lifetime_warranty=skuMap.is_lifetime_warranty;

							let $warrantyPeriodExtend = $form.find('span[data-field="warrantyPeriodExtend"]');

							let $msg = $warrantyPeriodExtend.next('span');

							if(is_lifetime_warranty){

								//永久保修

								$warrantyPeriodExtend.html('Lifetime Warranty');

								$form.find('select[name="hasExtensionWarranty"]').css("display","none");

								$msg.html("");

							}else{

								if ($msg.data('msg') && $msg.data('msg').indexOf('${0}') != -1) {

									$warrantyPeriodExtend.html('');

									$msg.html($msg.data('msg').replace('${0}', warrantyperiodextend));

								} else {

									$warrantyPeriodExtend.html(warrantyperiodextend);

								}

							}

						

						

							

							console.log($warrantyPeriodExtend.html());

						}

					} else {

						let msg = data.errorMessgae;

						if (msg != null && msg.length > 0) {

							//提示信息

							warning(msg);

						} else {

							warning('Error getting order information, please retry');//获取订单信息失败，请重试。

						}

					}

				},

				error : function(XMLHttpRequest, textStatus, errorThrown) {

					danger('Something went wrong, please contact support');//操作异常，请联系管理员

				}

			});

		}

	}

	

	/**礼品选择页初始化***/

	var giftInitTable = function ($form, mainId) {

		let sessionKey = $form.find('input[name="sessionKey"]').val();

		let countryCode = $form.find('select[name="countryCode"]').val();

		let sellerSkuId = $form.find('select[name="sellerSkuId"]').val();

		let orderDetailId = $form.find('input[name="orderDetailId"]').val();

		console.log(countryCode);

		$.ajax({

			type : "post",

			url : 'buyer/getSellerGiftInfo',

			async: false,

			data : {"sessionKey" : sessionKey, 'sellerSkuId' : sellerSkuId,"countryCode":countryCode,"orderDetailId":orderDetailId},

			dataType : "json",

			success : function(data) {

				if (data.status == "success") {

					let sellerSku = data.responseData.sellerSkuBean;

					if (sellerSku != null) {

						$form.find('input[name="sellerSkuReview"]').val(sellerSku.sellerSkuReview);

						let sellerGiftBeanList = sellerSku.sellerGiftBeanList;

						if (sellerGiftBeanList && sellerGiftBeanList.length > 0) {

							let giftDataArray = new Array();

							for (let j = 0; j < sellerGiftBeanList.length; j++) {

								let sellerGiftBean = sellerGiftBeanList[j];

								var sObject = new Object;

								sObject.id = sellerGiftBean.sellerGiftId;

								sObject.sellerGiftCode = sellerGiftBean.sellerGiftCode;

								sObject.sellerskuid = sellerSkuId;

								sObject.sellerGiftName = sellerGiftBean.sellerGiftName;

								sObject.sellerGiftHint = sellerGiftBean.sellerGiftHint;

								sObject.sellerGiftType = sellerGiftBean.sellerGiftType;

								sObject.currencyIso = sellerGiftBean.sellerGiftCurrencyIso;

								sObject.picurl = sellerGiftBean.sellerGiftPicUrl;

								sObject.sellergiftsale = sellerGiftBean.sellerGiftSale;

								sObject.sellerGiftShortName = sellerGiftBean.sellerGiftShortName;

								sObject.tradeOrderDetailId = sellerSku.tradeOrderDetailId;

								if(sellerGiftBean.isEnable){

									giftDataArray.push(sObject);

								}

							}

							let	$sellerGiftId = $form.find('select[name="reviewGift.sellerGiftId"]');

							$sellerGiftId.data('giftdataarray', giftDataArray);

						}

					}

					initChooseGiftTabl($form, mainId);

				} else {

					let msg = data.errorMessgae;

					if (msg != null && msg.length > 0) {

						//提示信息

						warning(msg);

					} else {

						warning('Error getting order information, please retry');//获取订单信息失败，请重试。

					}

				}

			},

			error : function(XMLHttpRequest, textStatus, errorThrown) {

				danger('Something went wrong, please contact support');//操作异常，请联系管理员

			}

		});

	};

	

	/***

	 * 初始化页面订单详情数据

	 */

	var initOrderDetailInfo = function(sellerSkuList, $form, mainId) {

		let countryArray = new Array(), platformArray = new Array(), paidTimeArray = new Array(), sellerSkuIdArray = new Array();

		$form.find('select[name="sellerSkuId"]').data('sellerskulist', sellerSkuList);

		for (let i = 0; i < sellerSkuList.length; i++) {

			let sellerSku = sellerSkuList[i];

			/***

			 * 统计国家

			 */

			let countryCode = sellerSku.countryCode, isExistCountryCode = false;

			if (countryArray.length > 0) {

				for (let j = 0; j < countryArray.length; j++) {

					if (countryCode == countryArray[j]) {

						isExistCountryCode = true;

						break;

					}

				}

			}

			if (!isExistCountryCode) {

				countryArray.push(countryCode);

			}

			/***

			 * 统计平台

			 */

			let platform = sellerSku.platform, isExistPlatform = false;

			if (platformArray.length > 0) {

				for (let j = 0; j < platformArray.length; j++) {

					if (platform == platformArray[j]) {

						isExistPlatform = true;

						break;

					}

				}

			}

			if (!isExistPlatform) {

				platformArray.push(platform);

			}

			/***

			 * 统计付款时间

			 */

			let paidTimeStr = sellerSku.paidTimeStr, isExistPaidTimeStr = false;

			if (paidTimeArray.length > 0) {

				for (let j = 0; j < paidTimeArray.length; j++) {

					if (paidTimeStr == paidTimeArray[j]) {

						isExistPaidTimeStr = true;

						break;

					}

				}

			}

			if (!isExistPaidTimeStr) {

				paidTimeArray.push(paidTimeStr);

			}

			/***

			 * 统计商品id

			 */

			let sellerSkuId = sellerSku.sellerSkuId, isExistSellerSkuId = false;

			if (sellerSkuIdArray.length > 0) {

				for (let j = 0; j < sellerSkuIdArray.length; j++) {

					if (sellerSkuId == sellerSkuIdArray[j]) {

						isExistSellerSkuId = true;

						break;

					}

				}

			}

			if (!isExistSellerSkuId) {

				sellerSkuIdArray.push(sellerSkuId);

			}

			

			if (sellerSku.marketingType == 'WARRANTY_AND_REVIEW_GIFT') {

				/***

				 * 礼品初始化数据填充

				 */

				let	$sellerGiftId = $form.find('select[name="reviewGift.sellerGiftId"]'),

					giftDataArray = $sellerGiftId.data('giftdataarray');

				if (giftDataArray == null) {

					giftDataArray = new Array();

				}

				let sellerGiftBeanList = sellerSku.sellerGiftBeanList;

				if (sellerGiftBeanList && sellerGiftBeanList.length > 0) {

					for (let j = 0; j < sellerGiftBeanList.length; j++) {

						let sellerGiftBean = sellerGiftBeanList[j];

						var sObject = new Object;

						sObject.id = sellerGiftBean.sellerGiftId;

						sObject.sellerGiftCode = sellerGiftBean.sellerGiftCode;

						sObject.sellerskuid = sellerSkuId;

						sObject.sellerGiftName = sellerGiftBean.sellerGiftName;

						sObject.sellerGiftHint = sellerGiftBean.sellerGiftHint;

						sObject.sellerGiftType = sellerGiftBean.sellerGiftType;

						sObject.currencyIso = sellerGiftBean.sellerGiftCurrencyIso;

						sObject.picurl = sellerGiftBean.sellerGiftPicUrl;

						sObject.sellergiftsale = sellerGiftBean.sellerGiftSale;

						sObject.sellerGiftShortName = sellerGiftBean.sellerGiftShortName;

						sObject.tradeOrderDetailId = sellerSku.tradeOrderDetailId;

						giftDataArray.push(sObject);

					}

				}

				$sellerGiftId.data('giftdataarray', giftDataArray);

			} 

		}

		//选择国家

		if (countryArray.length == 1) {

			$form.find('select[name="countryCode"]').find('option[value="'+ countryArray[0] +'"]').attr('selected', 'selected');

		}

		//选择平台

		if (platformArray.length == 1) {

			$form.find('select[name="platform"]').find('option[value="'+ platformArray[0] +'"]').attr('selected', 'selected');

		}

		//选择付款时间

		if (paidTimeArray.length == 1) {

			$form.find('input[name="paidTimeStr"]').val(paidTimeArray[0]);

		}

		/**初始化日期选择器**/

		datetimepicker(mainId);

		/**订单下商品选择框初始化方法**/

		sellerSkuIdOnChangeInit(mainId);

		//选择商品

		if (sellerSkuIdArray.length == 1) {

			let $option = $form.find('select[name="sellerSkuId"]').find('option[value="'+ sellerSkuIdArray[0] +'"]');

			$option.attr('selected', 'selected');

		}

	};

	

	/**初始化日期选择器**/

	var datetimepicker = function(mainId) {

//		$.fn.datetimepicker.dates['zh-CN'] = {

//	            days: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],

//	            daysShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],

//	            daysMin:  ["日", "一", "二", "三", "四", "五", "六", "日"],

//	            months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],

//	            monthsShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],

//	            today: "今天",

//	            suffix: [],

//	            meridiem: ["上午", "下午"]

//	    };

		let $form = $('form.initCustomForm' + mainId);

		let locale = $form.find('input[name="locale"]').val();

		let localLanguage = 'en';

		/****

		 * 加载对应语言

		 */

		if (new RegExp("^de.*$").test(locale)) {

			localLanguage = 'de';

		} else if (new RegExp("^es.*$").test(locale)) {

			localLanguage = 'es';

		} else if (new RegExp("^fr.*$").test(locale)) {

			localLanguage = 'fr';

		} else if (new RegExp("^it.*$").test(locale)) {

			localLanguage = 'it';

		} else if (new RegExp("^ja.*$").test(locale)) {

			localLanguage = 'ja';

		}

		console.log('------------------->localLanguage:' + localLanguage);


		$form.find('input[name="paidTimeStr"]').datetimepicker({

		    format: 'yyyy-mm-dd',

		    autoclose: true,//选择后自动关闭

		    pickerPosition: "bottom-left",

//		    startView: "year", //初始化视图是‘年’

            minView: "month",//最精确视图为'月'

            maxView: "decade",//最高视图为'十年'

//            todayBtn:true,//跳转到当天

//            language:'zh-CN',//语种：uk、en、zh-CN、de

            language:localLanguage,

		});

	};

	

	/**订单下商品选择框初始化方法**/

	var sellerSkuIdOnChangeInit = function(mainId) {

		let $form = $('form.initCustomForm' + mainId), $obj = $form.find('select[name="sellerSkuId"]');

		let _platform = $form.find('select[name="platform"]').val();

		

		let sellerskulist = $obj.data('sellerskulist');

		$obj.html('');

		$obj.html('<option value="">' + 'Please Choose' + '</option>');//请选择

		if (sellerskulist != null && sellerskulist.length > 0) {

			let sellerSkuIdCopyArray = new Array();

			for (let i = 0; i < sellerskulist.length; i++) {

				let sellerSku = sellerskulist[i];

				if (_platform != null && _platform != undefined && _platform.length > 0 && _platform != sellerSku.platform) {

					continue;

				}

				let isExist = false;

				if (sellerSkuIdCopyArray.length > 0) {

					for (let j = 0; j < sellerSkuIdCopyArray.length; j++) {

						if (sellerSku.sellerSkuId == sellerSkuIdCopyArray[j]) {

							isExist = true;

							break;

						}

					}

				}

				if (!isExist) {

//					$obj.append('<option value="'+ sellerSku.sellerSkuId +'">' + sellerSku.sellerSkuCode + '</option>');

					$obj.append('<option value=""></option>');

					let $lastOption = $obj.find('option:last');

					$lastOption.val(sellerSku.sellerSkuId);

//					$lastOption.html(sellerSku.sellerSkuCode);

					$lastOption.html(sellerSku.sellerSkuShortName);


					$lastOption.data('sku-name', sellerSku.sellerSkuName);

					$lastOption.data('sku-countrycode', sellerSku.countryCode);

					$lastOption.data('sku-platform', sellerSku.platform);

					$lastOption.data('sku-warrantyperiodextend', sellerSku.warrantyPeriodExtend);

					$lastOption.data('sku-marketingtype', sellerSku.marketingType);

					$lastOption.data('sku-sellerskureview', sellerSku.sellerSkuReview);

					$lastOption.data('sku-picurl', sellerSku.sellerSkuPicUrl);

					$lastOption.data('sku-tradeorderdetailid', sellerSku.tradeOrderDetailId);

					sellerSkuIdCopyArray.push(sellerSku.sellerSkuId);

				}

			}

			/**只有一个时默认选中**/

			if (sellerSkuIdCopyArray != null && sellerSkuIdCopyArray.length == 1) {

				$obj.find('option:last').attr('selected', 'selected');

			}

		}

		$obj.valid();

		/**选择商品事件**/

		sellerSkuIdOnChange(mainId);

	};

	

	/**选择商品事件**/

	var sellerSkuIdOnChange = function (mainId) {

		let $form = $('form.initCustomForm' + mainId), $obj = $form.find('select[name="sellerSkuId"]');

		let name = $obj.find('option:checked').data('sku-name');

		if (name == null || name == undefined) {

			name = '';

		}

		let picurl = $obj.find('option:checked').data('sku-picurl');

		if (picurl == null || picurl == undefined) {

			picurl = '/assets/img/default-avatar.png';

		}

		let warrantyperiodextend = $obj.find('option:checked').data('sku-warrantyperiodextend');

		if (warrantyperiodextend == null || warrantyperiodextend == undefined) {

			warrantyperiodextend = 0;

		}

		$form.find('p[data-field="sellerSkuName"]').html(name);

		$form.find('img[data-field="sellerSkuPicurl"]').attr('src', picurl);

		let $warrantyPeriodExtend = $form.find('span[data-field="warrantyPeriodExtend"]');

		let $msg = $warrantyPeriodExtend.next('span');

		if ($msg.data('msg') && $msg.data('msg').indexOf('${0}') != -1) {

			$warrantyPeriodExtend.html('');

			$msg.html($msg.data('msg').replace('${0}', warrantyperiodextend));

		} else {

			$warrantyPeriodExtend.html(warrantyperiodextend);

		}

		$form.find('input[name="sellerSkuReview"]').val($obj.find('option:checked').data('sku-sellerskureview'));

	};

	

	/**礼品选择页初始化***/

	var initChooseGiftTabl = function ($form, mainId) {

		let $sellerSkuId = $form.find('select[name="sellerSkuId"]'),

			$sellerGiftId = $form.find('select[name="reviewGift.sellerGiftId"]'),

			giftDataArray = $sellerGiftId.data('giftdataarray')

		;

		let sellerSkuId = $sellerSkuId.val();

		let tradeOrderdetailId = $sellerSkuId.find('option:checked').data('sku-tradeorderdetailid');

		$sellerGiftId.html('<option value="">' + 'Please Choose' + '</option>');

		if (giftDataArray != null && giftDataArray.length > 0) {

			let sellerGiftIdCopyArray = new Array();

			for (let i = 0; i < giftDataArray.length; i++) {

				let giftData = giftDataArray[i];

//				if (giftData.sellerskuid == sellerSkuId) {

				if (giftData.tradeOrderDetailId == tradeOrderdetailId) {

					let isExist = false;

					if (sellerGiftIdCopyArray.length > 0) {

						for (let j = 0; j < sellerGiftIdCopyArray.length; j++) {

							if (giftData.id == sellerGiftIdCopyArray[j]) {

								isExist = true;

								break;

							}

						}

					}

					if (!isExist) {

//						$form.find('select[name="reviewGift.sellerGiftId"]').append('<option value="'+ giftData.id +'">' + giftData.sellerGiftCode + '</option>');

						$form.find('select[name="reviewGift.sellerGiftId"]').append('<option value=""></option>');

						let $lastOption = $form.find('select[name="reviewGift.sellerGiftId"]').find('option:last');

						$lastOption.val(giftData.id);

//						$lastOption.html(giftData.sellerGiftCode);

						$lastOption.html(giftData.sellerGiftShortName);

						$lastOption.data('gift-sellerskuid', giftData.sellerskuid);

						$lastOption.data('gift-name', giftData.sellerGiftName);

						console.log("giftData.sellerGiftHint="+giftData.sellerGiftHint);

						$lastOption.data('gift-hint', giftData.sellerGiftHint);

						$lastOption.data('gift-type', giftData.sellerGiftType);

						$lastOption.data('gift-currencyiso', giftData.currencyIso);

						$lastOption.data('gift-picurl', giftData.picurl);

						$lastOption.data('gift-sellergiftsale', giftData.sellergiftsale);

						sellerGiftIdCopyArray.push(giftData.id);

					}

				}

			}

		}

		console.log("buyerEmail-->"+$form.find('input[name="buyerEmail"]').val());

		$form.find('input[name="reviewGift.confirmEmail"]').val($form.find('input[name="buyerEmail"]').val());

		/**选择礼品事件**/

		sellerGiftIdOnChange(mainId);

	};

	

	/**选择礼品事件**/

	var sellerGiftIdOnChange = function (mainId) {

		let $form = $('form.initCustomForm' + mainId);

		let $obj = $form.find('select[name="reviewGift.sellerGiftId"]');

		let name = $obj.find('option:checked').data('gift-name');

		if (name == null || name == undefined) {

			name = '';

		}

		let hint = $obj.find('option:checked').data('gift-hint');

		if (hint == null || hint == undefined) {

			hint = '';

		}

		let picurl = $obj.find('option:checked').data('gift-picurl');

		if (picurl == null || picurl == undefined) {

			picurl = '/assets/img/default-avatar.png';

		}

		$form.find('p[data-filed="giftName"]').html(name);

		$form.find('p[data-filed="giftHint"]').html(hint);

		$form.find('img[data-filed="giftPicUrl"]').attr('src', picurl);

		let currencyiso = $obj.find('option:checked').data('gift-currencyiso');

		let sellergiftsale = $obj.find('option:checked').data('gift-sellergiftsale');

		if (sellergiftsale) {

			$form.find('[data-filed="giftSellergiftsaleDiv"]').show();

		} else {

			$form.find('[data-filed="giftSellergiftsaleDiv"]').hide();

		}

		if (currencyiso == null || currencyiso == undefined || currencyiso == '') {

			currencyiso = '';

		}

		if (sellergiftsale == null || sellergiftsale == undefined || sellergiftsale == '') {

			sellergiftsale = '';

		}

		$form.find('[data-filed="giftCurrencyiso"]').html(currencyiso);

		$form.find('[data-filed="giftSellergiftsale"]').html(sellergiftsale);

		

		let type = $obj.find('option:checked').data('gift-type');

		showGiftType(type, $form);

	};

	

	// 礼品卡、优惠券   是email    现金是paypal  实物和其它 是地址信息

	var showGiftType = function (type, $form) {

		switch (type) {

			case "COUPON":

			case "GIFTCARD":

				$form.find("div[role='confirmEmail']").css("display","");

				$form.find("div[role='paypal']").css("display","none");

				$form.find("div[role='address']").css("display","none");

				break;

			case "CASH":

				$form.find("div[role='confirmEmail']").css("display","none");

				$form.find("div[role='paypal']").css("display","");

				$form.find("div[role='address']").css("display","none");

				break;

			case "ENTITY":

				$form.find("div[role='confirmEmail']").css("display","none");

				$form.find("div[role='paypal']").css("display","none");

				$form.find("div[role='address']").css("display","");

				break;

			default:

				$form.find("div[role='confirmEmail']").css("display","none");

				$form.find("div[role='paypal']").css("display","none");

				$form.find("div[role='address']").css("display","none");

				break;

		}

	};

	

	/**保修查询页面初始化**/

	var searchInit = function (mainId) {

//		$("[data-toggle='popover']").popover();

		

		let $form = $('form.searchCustomForm' + mainId);

		$form.find('[name="searchValue"]').bind("keydown",function(e){

			// 兼容FF和IE和Opera

			var theEvent = e || window.event;

			var code = theEvent.keyCode || theEvent.which || theEvent.charCode;

			if (code == 13) {

				//回车执行查询

				$('button.custom_search_btn' + mainId).click();

				e.preventDefault();

			}

		});

		

		/***

		 * 查询按钮点击事件

		 */

		$('button.custom_search_btn' + mainId).click(function() {

			let $obj = $(this);

			let $form = $obj.closest('form.searchCustomForm' + mainId);

			let searchValue = $form.find('input[name="searchValue"]').val();

			if (searchValue == null || searchValue == undefined || searchValue.length <= 0) {

				info('Please input your Warranty No or Email');//Please input your Warranty No or Email

				return ;

			}

			

			closebtn($obj);

			$.ajax({

     			type : "post",

     			url : 'buyer/buyerRegisterSearch',

     			data : $form.serializeArray(),

     			dataType : "json",

     			success : function(data) {

     				openbtn($obj);

     				/**封装数据**/

     				regitsterSearchListTable(data.responseData != null ? data.responseData.list : null, mainId);

     				if (data.status != "success") {

     					let msg = data.errorMessage;

     					if (msg != null && msg.length > 0) {

     						warning(msg);

     					} else {

     						warning('Something went wrong, please contact support');//查询失败，请重试.

     					}

     				}

     			},

     			error : function(XMLHttpRequest, textStatus, errorThrown) {

     				console.log(XMLHttpRequest);

     				console.log(textStatus);

     				console.log(errorThrown);

    				danger('Something went wrong, please contact support');//操作异常，请联系管理员

    				openbtn($obj);

     			}

     		});

		});

		

		/***

		 * 用于保修注册成功邮件查询：带参查询

		 */

		let searchValue = $form.find('[name="searchValue"]').val();

		if (searchValue != null && searchValue != undefined && searchValue.length > 0) {

			$('button.custom_search_btn' + mainId).click();

		}

	};

	

	/****

	 * 封装保修查询记录结果数据

	 */

	var regitsterSearchListTable = function (list, mainId) {

		let $div = $('div#custom_warrantyEnquirySearch' + mainId);

		let templateClass = 'warrantyEnquiry_table_template' + mainId;

		let $template = $div.find('div.' + templateClass);

		let $table = $div.find('div.warrantyEnquiry_table' + mainId);

		$table.html('');

		if (list == null || list == undefined || list.length <= 0) {

			return ;

		}

		let html = $template.html();

		for (let i = 0; i < list.length; i++) {

			let registerProduct = list[i];

			$div.find('div.warrantyEnquiry_table' + mainId).append(html);

			let $newDiv = $div.find('div.warrantyEnquiry_table' + mainId).find('div.warrantyEnquiry_table_template');

			//保修编号

			$newDiv.find('[data-field="warrantyCode"]').html(registerProduct.warrantyCode);

			//sku 名称

			$newDiv.find('[data-field="sellerSkuName"]').html(registerProduct.sellerSkuName);

			let warrantyTimeStr = '';

			if (registerProduct.warrantyEndTime != null) {

				warrantyTimeStr += registerProduct.warrantyLength + '&nbsp;'+ 'months' +' (' + 'from' + '&nbsp;';

				warrantyTimeStr += moment(registerProduct.paidTime).format("DD-MM-YYYY");

				warrantyTimeStr += ')';

			}

			//保险记录

			$newDiv.find('[data-field="warrantyTimeStr"]').html(warrantyTimeStr);

			$newDiv.removeClass('warrantyEnquiry_table_template');

			$newDiv.show();

		}

	};

	

	/**提交评价时，复制评价内容到剪贴板初始化数据**/

	var clipboardInit = function (mainId) {

		let $finshBtn = $('form.initCustomForm' + mainId).find('input[name=finish]');

		let clipboardInit = $finshBtn.data('clipboard-init');

		if (clipboardInit == null) {

			var clipboard = new ClipboardJS('input[name=finish]');

			clipboard.on('success', function(e) {

				console.info('Action:', e.action);

				console.info('Text:', e.text);

				console.info('Trigger:', e.trigger);

				e.clearSelection();

			});

			clipboard.on('error', function(e) {

				console.error('Action:', e.action);

				console.error('Trigger:', e.trigger);

			});

			$finshBtn.data('clipboard-init', true);

		}

	};

	

	/**保修风格调整**/

	var initWarrantyStyle = function (mainId, warrantyStyle) {

		if (warrantyStyle == 'MINIMALISM_ADJUST') {

			$('div.image-container').removeClass('custom-img-wizard');//去除默认的背景图片

//			$('.btn-finish').removeClass('btn-warning');//去除完成按钮颜色

//			$('.btn-next').removeClass('btn-warning');//去除下一步按钮颜色

			$('.btn-finish').removeClass('btn btn-warning btn-warning btn-wd');//去除完成按钮颜色

			$('.btn-next').removeClass('btn btn-warning btn-warning btn-wd');//去除下一步按钮颜色

			$('div.image-container').addClass('custom-img-wizard-profile').addClass('custom-font-style-italic');

//			$('.btn-finish').addClass('btn-success').addClass('custom-btn-circular');

//			$('.btn-next').addClass('btn-success').addClass('custom-btn-circular');

			$('.btn-finish').addClass('button button-pill button-action');

			$('.btn-next').addClass('button button-pill button-action');

		}else if (warrantyStyle == 'MINIMALISM_CONCISE'){

            $('div.image-container').removeClass('custom-img-wizard');//去除默认的背景图片

            $('.btn-finish').removeClass('btn btn-warning btn-warning btn-wd');//去除完成按钮颜色

            $('.btn-next').removeClass('btn btn-warning btn-warning btn-wd');//去除下一步按钮颜色

            $('div.image-container').addClass('custom-img-concise_2').addClass('custom-font-style-italic');

            $('.btn-finish').addClass('button button-pill button-action');

            $('.btn-next').addClass('button button-pill button-action');

        }else if (warrantyStyle == 'MINIMALISM_WIZARD'){

            $('div.image-container').removeClass('custom-img-wizard');//去除默认的背景图片

            $('.btn-finish').removeClass('btn btn-warning btn-warning btn-wd');//去除完成按钮颜色

            $('.btn-next').removeClass('btn btn-warning btn-warning btn-wd');//去除下一步按钮颜色

            $('div.image-container').addClass('custom-img-wizard-book').addClass('custom-font-style-italic');

            $('.btn-finish').addClass('button button-pill button-action');

            $('.btn-next').addClass('button button-pill button-action');

        }

	};

	

	var initCustomizedStyle=function(mobile){

		$('div.image-container').removeClass('custom-img-wizard-boat custom-img-wizard custom-img-wizard-city custom-img-wizard-profile custom-img-wizard-book');

		$('div.image-container').addClass('custom-img-profile-'+mobile);

		$("#reviewContent textarea").addClass("reviewMinCheck");

		$("#reviewContent label").prepend('<span class="cutom_required">*</span>');

		$('div.image-container').css("background-position",'inherit');

		firstNameMsg="Please enter the Name";

	}

	jQuery.validator.addMethod("reviewMinCheck", function(value, element) {

		   return value.length>=20;

		}, "Too little content");

	return {

		/**买家注册页面初始化**/

		init : function(mainId) {

			init(mainId);

		},

		/**保修查询页面初始化**/

		searchInit : function (mainId) {

			searchInit(mainId);

		},

		/**保修风格调整**/

		initWarrantyStyle : function (mainId, warrantyStyle) {

			initWarrantyStyle(mainId, warrantyStyle);

		},

		/****设置自定义风格**/

		initCustomizedStyle:function(mobile){

			initCustomizedStyle(mobile);

		},

		/**弹框**/

		warning: function(text){

			warning(text)

		},

		/**原始风格*/

		validWarrantyLink: function (form) {

			validWarrantyLink(form)

		},

		/**自定义风格*/

		validWarrantyLinkByCustom: function (form) {

			validWarrantyLinkByCustom(form)

		},

        /**根据ItemNo校验商品是否属于该域名下*/

		validWarrantyLinkByItemNo: function (form) {

			validWarrantyLinkByItemNo(form)

		},


		/**根据判断是否属于当前域名*/

		validWarrantyLinkBySellerSkuId: function(form){

			validWarrantyLinkBySellerSkuId(form)

		},




	}

}();

